export const errorMessages= {
  "Firebase: Error (auth/invalid-credential).":
    "Invalid credentials. Please check your input and try again.",
  "Firebase: Error (auth/invalid-email).":
    "Invalid email format. Please enter a valid email address.",
  "Firebase: Missing password requirements: [Password must contain at least 6 characters, Password must contain an upper case character, Password must contain a numeric character] (auth/password-does-not-meet-requirements).":
    "Your password must be at least 6 characters long, contain at least one uppercase letter, and one number.",

  "Firebase: Error (auth/email-already-in-use).":
    "This email is already registered.",
  default: "An error occurred. Please try again.",
};
